import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
export interface ContentLineData{
    title: string;
    thumbnail: string;
    tag: string;
    quizNum: number;
    annotationNum: Number;
    durationAvg: Number;
    usersNum: Number;
    userPercent: Number;
  }

@Component({
  selector: 'contents-stat-item',
  templateUrl: './contents-stat-item.component.html',
  styleUrls: ['./contents-stat-item.component.scss']
})
export class ContentsStatItem implements OnInit, OnChanges {
  @Input() data: ContentLineData;
  @Input() sceneId: string;
  
  constructor(
  ) {

  }
  ngOnInit(): void {
    
  }
  ngOnChanges(changes: SimpleChanges){
  }
  getLabel(){
    return (this.data.userPercent || 0) + '%';
  }

}
